import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import { MediaContentRow } from "services/cms/models/mediaContentRow";
import { MediaContentTable } from "services/cms/models/mediaContentTable";

import mediaContentRowResolver, { ResolvedMediaContentRow } from "./mediaContentRowResolver";

export type ResolvedMediaContentTable = {
    titleColumnHeader: string;
    dateColumnHeader: string;
    actionColumnHeader: string;
    contentRows: ResolvedMediaContentRow[];
    type: ContentTypeCodenames.MediaContentTable;
    codename: string;
};

const mediaContentTableResolver = (data: MediaContentTable): ResolvedMediaContentTable => {
    return {
        titleColumnHeader: data.elements.titleColumnHeader.value,
        dateColumnHeader: data.elements.dateColumnHeader.value,
        actionColumnHeader: data.elements.actionColumnHeader.value,
        contentRows: mediaContentRowResolver(
            data.elements.mediaContentRow.linkedItems as MediaContentRow[]
        ),
        type: ContentTypeCodenames.MediaContentTable,
        codename: data.system.codename,
    };
};

export default mediaContentTableResolver;
